import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, breakpoints, palette, typography }) => ({
  root: {
    position: 'fixed',
    zIndex: 2,
    backgroundColor: palette.common.white,
    boxShadow:
      '0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2)',
    bottom: 0,
    left: 0,
    paddingLeft: spacing(3),
    paddingRight: spacing(3),
    cursor: 'pointer',
    width: '100%',
    maxWidth: '100%',
    minWidth: '100%',
    [breakpoints.up('lg')]: {
      maxWidth: '313px',
      position: 'relative'
    }
  },
  title: {
    fontWeight: typography.fontWeightBold,
    width: '100%',
    fontSize: 'i6px',
    lineHeight: spacing(3)
  },
  navContainer: {
    paddingTop: spacing(2),
    paddingLeft: '0',
    [breakpoints.up('lg')]: {
      paddingTop: spacing(2)
    }
  },
  whatsNextContainer: {
    maxHeight: 'calc(100vh - 396px)',
    overflow: 'auto',
    [breakpoints.up('lg')]: {
      maxHeight: '430px'
    }
  },
  whatsNewText: {
    paddingTop: spacing(1),
    paddingBottom: spacing(1),
    overflow: 'initial',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: spacing(3)
  },
  completeContainer: {
    paddingBottom: spacing(5),
    paddingTop: spacing(3),
    maxHeight: 'calc(100vh - 396px)',
    overflow: 'auto',
    textAlign: 'center',
    [breakpoints.up('lg')]: {
      maxHeight: '430px'
    }
  },
  completeText: {
    padding: spacing(2, 2, 2, 2),
    fontFamily: 'Red Hat Display'
  },
  exploreMore: {
    backgroundColor: palette.accent.shade[5],
    borderRadius: 4
  },
  exploreMoreText: {
    padding: spacing(2),
    color: palette.grey.shade[100],
    fontFamily: 'Red Hat Display',
    textDecoration: 'none'
  },
  backButtonContainer: {
    paddingTop: spacing(2),
    display: 'none',
    [breakpoints.up('lg')]: {
      display: 'inline-block'
    }
  },
  playlistItems: {
    paddingTop: 0
  },
  playlistItem: {
    padding: spacing(1, 2),
    overflow: 'initial'
  },
  playlistLink: {
    alignItems: 'center',
    display: 'flex',
    textDecoration: 'none'
  },
  linkText: {
    '& span': {
      color: palette.grey.shade[100],
      fontSize: '14px',
      lineHeight: '20px',
      display: '-webkit-box',
      '-webkit-line-clamp': '2',
      '-webkit-box-orient': 'vertical',
      overflow: 'hidden'
    }
  },
  linkTextBold: {
    '& span': {
      fontWeight: typography.weight.bold,
      color: palette.grey.shade[100]
    }
  },
  viewedText: {
    color: palette.grey.shade[50],
    fontFamily: 'Red Hat Display'
  },
  navHeader: {
    padding: '0 0 16px',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  arrowIcon: {
    marginRight: spacing(2),
    transform: 'rotate(180deg)',
    [breakpoints.up('lg')]: {
      display: 'none'
    }
  },
  filterIcon: {
    display: 'none',
    [breakpoints.up('lg')]: {
      display: 'inline-block'
    }
  },
  arrowDown: {
    transform: 'rotate(0deg)'
  },
  arrowUp: {
    transform: 'rotate(180deg)'
  },
  divider: {
    backgroundColor: palette.grey.shade[5]
  },
  avatar: {
    width: '53px',
    marginRight: spacing(3)
  },
  skeleton: {
    borderRadius: 4,
    flexGrow: 1
  }
}))
